import { render, staticRenderFns } from "./ValorantLeaderboard.vue?vue&type=template&id=2f45e8ec&"
import script from "./ValorantLeaderboard.vue?vue&type=script&lang=js&"
export * from "./ValorantLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./ValorantLeaderboard.vue?vue&type=style&index=0&id=2f45e8ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports